module.exports = __webpack_public_path__ + "img/radio-selected-ring.ab7300fa.svg";